export default "__VITE_ASSET__256ce9de__"